import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { Dialog } from 'react-toolbox';
import styles from 'styles/input.scss';
import { updatePhaseTask, addEventToPhase } from 'actionCreators/phase';
import { getPhaseErrors } from '../../../../../../reducers';
import { errorSummary } from '../../../../../../utils';
import S from 'modal.scss';

class SendToFloorWizardModal extends Resetter(Validator(React.Component)) {
  static DEFAULT_STATE = {
    errors: {},
  }

  static VALIDATIONS = { status: true, note: true }

  handleSubmit = () => this.props.updatePhaseTask(
    this.props.phaseId, 'send_to_floor_wizard', { task: { status: 'n/a' } })
      .then((res) => {
        if (res.type === 'UPDATE_PHASE_TASK_SUCCESS') {
          this.props.addEventToPhase(this.props.phaseId, {
            name: 'Send Information to Floor Wizard',
            kind: 'floor_wizard',
            data: { note: 'Project resent to floorwizard from the action button', success: true },
          });
        }
      }).then(() => this.handleClose(),
  );

  handleClose() {
    super.handleClose();
  }

  render = () => {
    const { active, serverErrors } = this.props;
    return (<Dialog
      active={active}
      className={S.modal}
      type="fullscreen"
      onEscKeyDown={this.handleClose}
      onOverlayClick={this.handleClose}
    >
      <div className={styles.errored}>
        {serverErrors && Object.keys(serverErrors).length > 0 &&
          <span className={styles.error}>{errorSummary(serverErrors)}</span>}
      </div>
      <IconButton
        icon="close"
        className={S.close}
        onClick={this.handleClose}
        tabIndex={-1}
      />
      <h5 className={S.title}>Send Phase To Floor Wizard</h5>
      <p className={S.text}>
        Verify you want to do so, then click {'\'SEND\''} to re-send
        this phase to Floor Wizard
      </p>
      <Button
        label="Send"
        flat inverse ripple
        className={S.submit}
        onClick={this.handleSubmit}
      />
    </Dialog>);
  }
}

SendToFloorWizardModal.propTypes = {
  active: PropTypes.bool.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  addEventToPhase: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  phaseId: PropTypes.number.isRequired,
  serverErrors: PropTypes.shape({}),
};

SendToFloorWizardModal.defaultProps = { active: false };

export default connect(
  state => ({ serverErrors: getPhaseErrors(state) }),
  { updatePhaseTask, addEventToPhase })(SendToFloorWizardModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/sendToFloorWizardModal.jsx